export default __webpack_public_path__ + "static/media/Spark_productions.47740bda.jpg";